/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SaSheetColumn { 
    id?: string;
    name?: string;
    description?: string;
    code?: string;
    column_type?: string;
    data_type?: string;
    place_holder?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    sheet_id?: string;
    sort_order?: number;
    autosync_type?: string;
    output_salary_type?: string;
    select_options?: Array<string>;
}